import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})
export class LoginAdminComponent implements OnInit {

  @ViewChild("mensajeRecuperar") mensajeRecuperar: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  @ViewChild ("modalpass") modalpass:ElementRef;
  @ViewChild("botonCerrar") botonCerrar:ElementRef;
  usuario:string;
  password:string;
  primerIntento:boolean=true;
  usuariologin={};
  tipo:string;
  
  constructor(private auth:AuthService, private router:Router, private activatedRoute:ActivatedRoute,
              private renderer:Renderer2) {

    this.usuariologin={UScif:""};
                
    
    if(this.auth.isAuthenticated()){
      
      this.router.navigate(['home']);
    }
      

  }

  ngOnInit() {
  }

  loginAdmin(){
    this.auth.loginAdmin(this.usuario,this.password).subscribe(resp=>{
      
      if(resp==true){
        this.router.navigate(["/home"]);
      }else{
        this.auth.loginInterviniente(this.usuario, this.password).subscribe(resp=>{
          
          if(resp==true){
            this.router.navigate(["/home"]);
          }else{
            this.primerIntento=false;
            this.usuario="";
            this.password="";
          }
        });
      }
    });
  }

  guardarNuevaPass(myform: NgForm){
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
    if(myform.valid){
      
      this.auth.recuperarPassUsuarioInterviniente(this.usuariologin)
      .subscribe(resp=>{
        let texto=this.renderer.createText("");
        
        if(resp["err"]==false){
          texto=this.renderer.createText("Se le ha enviado su nueva contraseña al correo.");
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement, "color", "green");
        }else{
          texto=this.renderer.createText(resp["msg"]);
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement, "color", "red");
        }
        this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
          this.botonCerrar.nativeElement.click();
        }, 2000);
      });
      
    }else{
      let texto=this.renderer.createText("Faltan campos en el formulario.");
        this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
        this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
        }, 1500);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login-admin/login-admin.component.ts